import { Reducer } from "redux";

import { UserModifiedResponse } from "../models/Api/User";
import { UserModifiedDispatchTypes } from "../models/DispatchTypes/User";
import { UserModifiedActionDispatchTypes } from "../constants/User";

export const initialState: UserModifiedResponse = {
    loading: false,
    response: {
        isUserModified: false,
        modifiedOn: null
    }
};

const UserModifiedReducer: Reducer<
    UserModifiedResponse,
    UserModifiedDispatchTypes
> = (state = initialState, action) => {
    switch (action.type) {
        case UserModifiedActionDispatchTypes.GET_USER_DETAILS_MODIFIED_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case UserModifiedActionDispatchTypes.GET_USER_DETAILS_MODIFIED_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
        case UserModifiedActionDispatchTypes.GET_USER_DETAILS_MODIFIED_ERROR: {
            return {
                ...state,
                response: initialState.response,
                loading: false,
            };
        }
    }
    return state;
};

export default UserModifiedReducer;
